import template from './kform-errors.html';

const kformErrorsDirective = /* @ngInject */ () => ({
	scope: false,
	restrict: 'E',
	template,
});

export default kformErrorsDirective;
